export enum EKwikUIInputDateSize {
  S = "s",
  M = "m",
  L = "l"
}
export const VKwikUIInputDateSize = [
  EKwikUIInputDateSize.S,
  EKwikUIInputDateSize.M,
  EKwikUIInputDateSize.L
] as const;

export type TKwikUIInputDateSize = (typeof VKwikUIInputDateSize)[number];
